import React from 'react';
import Summary from './Summary';
import Similar from './Similar';
import Suggestions from './Suggestions';
import Stack from '@mui/material/Stack';

var _ = require('lodash');

export default function DetailsContent() {
    return (
        <Stack spacing={2}>
            <Summary data={"Summary data"} />
            <Similar data={"Similar data"} />
            <Suggestions data={"Suggestions data"} />
        </Stack>
    )
}


